import reportTypes from "./word-map/report_types.json";
import reportLabels from "./word-map/labels.json";
import reportSections from "./word-map/ui_group_titles.json";
import translatedLabels from "./word-map/translate_prop_to_label.json"
import parsedValues from "./word-map/parsed_values.json";
import genericConstants from "./word-map/nomes_genericos.json";
import sourceLabels from "./word-map/source_labels.json";
import pluralWords from "./word-map/nomes_genericos.json";
import relacoesVinculos from "./word-map/relacoes_vinculos.json";
import multiplosRegistros from "./word-map/multiplos_registros.json";
import { AiModelOption } from "../global";

export const REPORT_CONSTANTS = reportTypes;
export const REPORT_LABELS = reportLabels;
export const REPORT_SECTIONS = reportSections;
export const GENERIC_CONSTANTS = genericConstants;
export const SOURCE_LABELS = sourceLabels;
export const TRANSLATED_LABELS = translatedLabels;
export const PARSED_VALUES = parsedValues;
export const PLURAL_WORDS = pluralWords.getPluralWord;
export const RELACOES_VINCULOS = relacoesVinculos;
export const MULTIPLOS_REGISTROS_DETALHES = multiplosRegistros.detalhes;
export const RELACOES_REPORT = reportTypes.relacoes_report;

export const FIELD_KEYS = {
    CPF: MULTIPLOS_REGISTROS_DETALHES.cpf,
    DATA_NASCIMENTO: MULTIPLOS_REGISTROS_DETALHES['data de nascimento'],
    IDADE: MULTIPLOS_REGISTROS_DETALHES.idade,
    SEXO: MULTIPLOS_REGISTROS_DETALHES.sexo,
    NOME_DA_MAE: MULTIPLOS_REGISTROS_DETALHES['nome_da_mae'],
} as const;

export const MAX_PAGE_HEIGHT = "max-h-[calc(100vh-212px)]"

export const TRASH_CONTAINER_ID = "report-content-trash";
export const DEFAULT_CONTAINER_ID = "report-content";

export const DEFAULT_AI_MODEL_OPTIONS: AiModelOption[] = [
  {
    value: "local",
    label: "Modo Privado",
    subtitle: "Dados tratados no servidor local • Respostas mais simples",
    tooltip: "Processamento em servidor local — os dados não são enviados a provedores externos. Possui menor capacidade de processamento em tarefas complexas.",
  },
  {
    value: "nuvem",
    label: "Modo Nuvem",
    subtitle: "Dados enviados a servidores externos • Mais capacidade e qualidade",
    tooltip: "Processamento em servidores de IA externos — os dados serão enviados ao provedor para gerar respostas mais avançadas.",
  },
];